module.exports = __webpack_public_path__ + "media/morningCoffee.29a3f284.mp3";